import cardValidator from 'card-validator';

export const isValidCardNumber = (value: string): boolean => {
  const cardInfo = cardValidator.number(value);

  if (cardInfo.card === null) {
    return false;
  }

  return Boolean(cardInfo.isValid && cardInfo.isPotentiallyValid);
};
